var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoTvSolid = function SvgIcoTvSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    fill: "#fff",
    viewBox: "0 0 30 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 0C1.08 0 .333.746.333 1.667V17c0 .92.746 1.667 1.667 1.667h26c.92 0 1.667-.747 1.667-1.667V1.667C29.667.747 28.92 0 28 0zm18.333 24H9.667a1.333 1.333 0 0 1 0-2.667h10.666a1.333 1.333 0 0 1 0 2.667",
    clipRule: "evenodd"
  })));
};
export default SvgIcoTvSolid;